import React from 'react';
import { View, Text, ScrollView } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';

import EditableLine from '@components/common/editableLine';
import Line from '@components/common/line';

import ColorWrapper from '@styles/colors/index';
import { font } from '@styles/fonts';

import { getBoxShadowStyle } from '@styles/shadow';

import Header from '@components/settings/v2/common/SettingsHeader';
import { BACK_BUTTON_SETTINGS_TEXT, SCREEN_BORDER_RADIUS, TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { useManageNotifications } from './hooks/useManageNotifications';

const Notifications = (props) => {
  const { C, rootStack } = props;

  const { notifyOnMachineErrors, notificationLoading, triggerNotification, navigateToEmailReports } = useManageNotifications({ rootStack });

  const shadowStyles = getBoxShadowStyle({ type: 'Field', C });

  const reports = [
    {
      name: i18n.t('Email Reports'),
      value: '',
      onClick: navigateToEmailReports,
      testID: TEST_IDS.settingsScreen.emailReportsLink,
    },
  ];

  return [
    <View key="Notifications" style={{ width: '100%', height: '100%', backgroundColor: C('Background/Light/Detail'), alignItems: 'center' }}>
      <Header backBtnText={BACK_BUTTON_SETTINGS_TEXT} name={'Notifications'} key={'CompanyHeader'} />
      <ScrollView style={{ width: '100%', flex: 1 }} contentContainerStyle={{ paddingBottom: scale(50) }}>
        <View
          style={{
            paddingHorizontal: scale(18),
          }}
        >
          <View>
            <View style={{ paddingLeft: scale(15), marginBottom: scale(5) }}>
              <Text style={[font.Footnote, { color: C('Label/Light/Tertiary') }]}>{i18n.t('NOTIFICATION')}</Text>
            </View>
            <View testID={TEST_IDS.settingsScreen.notificationsToggle} style={[shadowStyles, { borderRadius: scale(SCREEN_BORDER_RADIUS) }]}>
              <EditableLine
                {...{
                  item: {
                    value: notifyOnMachineErrors,
                    key: 'switchedOn',
                    name: 'Notify on machine errors',
                    noArrow: true,
                    isLable: true,
                    oneLine: true,
                    small: false,
                    width: 270,
                    type: 'boolean',
                    loading: notificationLoading,
                    onChange: (v) => triggerNotification(v),
                  },
                  index: 0,
                  array: [{}],
                  C,
                  topBorder: false,
                  bottomBorder: false,
                  roundTop: true,
                  roundBottom: true,
                }}
              />
            </View>
            <View style={{ paddingHorizontal: scale(15), marginTop: scale(6) }}>
              <Text style={[font['Caption 1'], { color: C('Label/Light/Tertiary') }]}>
                {i18n.t('All users of your organization will be notified if a machine has an error while running in automatic mode')}
              </Text>
            </View>
          </View>
          <View>
            <View style={{ paddingLeft: scale(15), marginTop: scale(30), marginBottom: scale(5) }}>
              <Text style={[font.Footnote, { color: C('Label/Light/Tertiary') }]}>{i18n.t('SCHEDULED REPORTS')}</Text>
            </View>
            <View style={[shadowStyles, { borderRadius: scale(SCREEN_BORDER_RADIUS) }]}>
              {reports.map((item, index) => (
                <Line
                  {...{ item, index, array: reports, C, roundBottom: reports.length - 1 === index, roundTop: index === 0, topBorder: index !== 0 }}
                  key={item.name}
                />
              ))}
            </View>
          </View>
        </View>
      </ScrollView>
    </View>,
  ];
};

export default ColorWrapper(Notifications);
